import { AwsRumConfig } from "aws-rum-web";

export const RUM_CONFIG: AwsRumConfig = {
  sessionSampleRate: 1,
  endpoint: "https://dataplane.rum.us-west-2.amazonaws.com",
  telemetries: ["performance","errors", ["http",{recordAllRequests: true}]],
  allowCookies: true,
  enableXRay: false,
};
